import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scm-error-log" }
const _hoisted_2 = { class: "tag-tree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_logistics_info_dialog = _resolveComponent("logistics-info-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_page, null, {
      fheader: _withCtx(() => [
        (_ctx.$has(_ctx.permissionConfig.CREATE))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logisticsModel('add')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(({
          height
        }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_tree, {
            data: _ctx.logisticsList,
            height: height,
            props: _ctx.defaultProps,
            "expand-on-click-node": false,
            "render-content": _ctx.renderContent
          }, null, 8, ["data", "height", "props", "render-content"])
        ])
      ]),
      ffooter: _withCtx(() => []),
      _: 1
    }),
    _createVNode(_component_logistics_info_dialog, {
      logisticsDialogVisible: _ctx.logisticsDialogVisible,
      "onUpdate:logisticsDialogVisible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.logisticsDialogVisible) = $event)),
      rowItem: _ctx.rowItem,
      logisticsType: _ctx.logisticsType,
      onUploadList: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch()))
    }, null, 8, ["logisticsDialogVisible", "rowItem", "logisticsType"])
  ]))
}